import { render, staticRenderFns } from "./Family-statements-search.vue?vue&type=template&id=19c1369e&scoped=true"
import script from "./Family-statements-search.vue?vue&type=script&lang=js"
export * from "./Family-statements-search.vue?vue&type=script&lang=js"
import style0 from "./Family-statements-search.vue?vue&type=style&index=0&id=19c1369e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c1369e",
  null
  
)

export default component.exports